import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CardComponent } from '../card/card.component';

@Component({
  selector: 'lyceo-single-card-layout',
  templateUrl: './single-card-layout.component.html',
  styleUrls: ['./single-card-layout.component.scss'],
  imports: [CardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleCardLayoutComponent {}
